module.exports = __webpack_public_path__ + "static/media/Zeng Lai.f3a4786f.png";